class UIChanger {
    constructor(element, params) {
        this.element = element;
        this.min = parseInt(this.element.dataset.min) || 0;
        this.max = parseInt(this.element.dataset.max) || Infinity;
        this.step = parseInt(this.element.dataset.step) || 1;
        this.value = parseInt(element.querySelector('.ui-changer__counter-input').value) || 0;
        this.lastValue = this.value;
        this.isBlocked = false;
        this.inputTimeout = undefined;
        
        this.counterInput = element.querySelector('.ui-changer__counter-input');
        this.minusBtn = element.querySelector('.ui-changer__btn_minus');
        this.plusBtn = element.querySelector('.ui-changer__btn_plus');
        this.unitSpan = element.querySelector('.ui-changer__counter-unit');
        
        this.bindEvents();
        if ('isDependantOnBasket' in params && params.isDependantOnBasket === true) {
            this.bindBasketEvents();
        }
    
        this.checkLimits();
        
        this.minusBtn.addEventListener('click', () => {
            if (!this.isBlocked) {
                this.decrease();
            }
        });
        
        this.plusBtn.addEventListener('click', () => {
            if (!this.isBlocked) {
                this.increase();
            }
        });
        
        this.counterInput.addEventListener('input', (event) => {
            if (!this.isBlocked) {
                this.handleInput();
            }
        });
    
        this.counterInput.addEventListener('focus', () => {
            this.handleFocus();
        });
    
        this.counterInput.addEventListener('blur', () => {
            this.acceptInputValue();
        });
        
        if (this.unitSpan) {
            this.unitSpan.addEventListener('click', () => {
                this.handleClickUnit();
            });
        }
    }
    
    setValue(value) {
        this.value = parseInt(value);
        this.checkLimits();
        this.lastValue = this.counterInput.value = this.value;
    }
    
    setMax(max) {
        this.max = max;
        this.checkLimits();
    }
    
    reinitLimits() {
        this.min = parseInt(this.element.dataset.min) || 0;
        this.max = parseInt(this.element.dataset.max) || Infinity;
        this.checkLimits();
        this.counterInput.value = this.value;
    }
    
    checkLimits() {
        this.value = Math.max(this.min, Math.min(this.max, this.value));
        this.counterInput.value = this.value;
        this.minusBtn.disabled = (this.value <= this.min);
        this.plusBtn.disabled = (this.value >= this.max);
    }
    
    decrease() {
        this.value = Math.max(this.min, this.value - this.step);
        this.checkLimits();
        this.triggerEvents({isDecrease: true, value: this.value});
    }
    
    increase() {
        this.value = Math.min(this.max, this.value + this.step);
        this.checkLimits();
        this.triggerEvents({isDecrease: false, value: this.value});
    }
    
    block() {
        this.isBlocked = true;
        this.element.classList.add('ui-changer__blocked');
    }
    
    unblock() {
        this.isBlocked = false;
        this.element.classList.remove('ui-changer__blocked');
    }
    
    // todo добавить в будущем прелоадер
    // showPreloader() {
    //    
    // }
    //
    // hidePreloader() {
    //    
    // }
    
    handleInput() {
        clearTimeout(this.inputTimeout);
        if (/\D/g.test(this.counterInput.value)) {
            this.counterInput.value = this.counterInput.value.replace(/\D/g, '');
        }
        
        if (this.counterInput.value < this.min || this.counterInput.value > this.max || this.counterInput.value === '') {
        } else {
            this.inputTimeout = setTimeout(() => {
                this.counterInput.blur();
                this.acceptInputValue();
            }, 1250);
        }
    }
    
    handleFocus() {
        this.lastValue = this.value;
    }
    
    handleClickUnit() {
        const end = this.counterInput.value.length;
        this.counterInput.setSelectionRange(end, end);
        this.counterInput.focus();
    }
    
    acceptInputValue() {
        this.value = parseInt(this.counterInput.value) || 0;
        this.checkLimits();
        if (this.value !== this.lastValue) {
            this.triggerEvents({isDecrease: this.value < this.lastValue, value: this.value});
        }
    }
    bindEvents() {
        this.element.addEventListener('bookchanger.setvalue', (event) => {
            this.setValue(event.detail.value);
        })
    }
    // todo костыльное решение, связанное с особенностями использования в других компонентах. Избавиться в дальнейшем
    bindBasketEvents() {
        this.element.addEventListener('bookchanger.block', (event) => {
            this.block();
        })
        this.element.addEventListener('bookchanger.unblock', (event) => {
            this.unblock();
        })
        this.element.addEventListener('bookchanger.setmax', (event) => {
            this.setMax(event.detail.max);
        })
    }
    
    triggerEvents(data = {}) {
        data.valueBefore = this.lastValue;
        this.lastValue = this.value;
        const eventInput = new Event('change');
        this.counterInput.dispatchEvent(eventInput);
        const eventWrap = new CustomEvent('uichanger-change', {detail: data, bubbles: true, cancelable: true});
        this.element.dispatchEvent(eventWrap);
    }
}
